<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_service_mail"></Header>
    <v-container fluid v-if="userTickets">
      <v-layout row wrap>
        <v-flex md5 xs12>
          <h3 class="message-title">Your Messages</h3>
          <table class="tickets-table">
            <thead>
              <tr>
                <th class="md-padding">
                  {{ "lng_service_title" | translate }}
                </th>
                <th class="md-padding">{{ "lng_service_date" | translate }}</th>
                <th class="md-padding">
                  {{ "lng_service_status" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(ticket, index) in userTickets"
                :key="ticket.ticketid + index"
              >
                <td>{{ ticket.title }}</td>
                <td>{{ ticket.date }}</td>
                <!-- <td v-if="ticket.status == 1"> -->
                <td>
                  <v-btn
                    depressed
                    small
                    class="answer-button"
                    @click="getTicketMessages(ticket.ticketid)"
                  >
                    {{
                      ticket.status == 1
                        ? "Waiting for answer from NBE"
                        : ticket.status == 2
                        ? "Waiting for answer from user"
                        : "Closed"
                    }}</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex md7 xs12 v-if="userMessages && showMessages">
          <h3 class="message-title">
            {{ userMessages.title }}
            <v-btn
              depressed
              small
              class="hide-button"
              @click="showMessages = false"
            >
              Hide</v-btn
            >
          </h3>
          <div
            v-for="(msgData, index) in userMessages.messages"
            :key="msgData.date + index"
          >
            <div class="message-body md-padding">
              <h4>{{ msgData.date }}</h4>
              <p class="message-text" v-html="msgData.message"></p>
            </div>
          </div>
          <div class="message-body">
            <vue-editor v-model="replyContent"></vue-editor>
          </div>
          <v-btn
            class="ml-5"
            color="primary"
            @click="sendReply(userMessages.ticketid)"
            :loading="loadingReply"
            :disabled="loadingReply"
            >Send</v-btn
          >
        </v-flex>
        <v-flex md7 xs12 v-if="showLoading">
          <v-img
            :src="require('../assets/images/spinner.svg')"
            contain
            height="50px"
          ></v-img>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import { translate } from "../common/HelperFunctions";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    Header,
    VueEditor
  },
  data: () => ({
    userTickets: undefined,
    userMessages: undefined,
    showMessages: false,
    showLoading: false,
    replyContent: "",
    loadingReply: false
    // alertToggle: false,
    // flashMessageData: {},
    // responseObj: {},
    // pageRefreshTime: 30,
    // timerKey: 0,
    // showTimer: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async FetchApisData() {
      this.userTickets = await GlobalService.getEmailTickets(
        this.getUser.token
      );
      // this.showTimer = true;
      this.$store.commit("global/setLoading", false);
    },
    async getTicketMessages(ticketId) {
      this.showLoading = true;
      this.showMessages = false;
      this.userMessages = await GlobalService.getTicketMessages(
        ticketId,
        this.getUser.token
      );
      this.showMessages = true;
      this.showLoading = false;
    },
    async sendReply(ticketId) {
      if (this.replyContent.trim()) {
        this.loadingReply = true;
        this.msgResponse = await GlobalService.sendTicketReply(
          this.replyContent,
          ticketId,
          this.getUser.token
        );
        this.loadingReply = false;
        this.replyContent = "";

        this.userMessages = await GlobalService.getTicketMessages(
          ticketId,
          this.getUser.token
        );
      }
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    // a funtion to refresh the page after specific time
    async refreshPage() {
      await this.FetchApisData();
      this.pageRefreshTime = 30;
      this.timerKey += 1;
    }
  }
};
</script>

<style>
.tickets-table {
  width: 100%;
  border-spacing: 0;
  padding: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 20px;
}
.tickets-table tr:nth-of-type(odd) {
  background: rgba(255, 255, 255, 0.6);
}
.tickets-table thead tr {
  background: 0 0 !important;
}
.tickets-table td,
.tickets-table thead tr th {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-right: 0;
  border-bottom: 0;
  color: #455a64;
}
.tickets-table td:last-child,
.tickets-table thead tr th:last-child {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.tickets-table td {
  margin: 0;
  padding: 15px 0;
  text-align: center;
}
.md-padding {
  padding: 16px;
}
.message-body {
  margin: 0 auto 10px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
}
h3.message-title {
  color: #455a64;
  text-align: center;
  margin: 5px 0 20px 0;
}
.message-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.87);
}
.hide-button {
  position: relative;
  top: 0;
  right: 0;
  text-decoration: underline;
  float: right;
  background-color: transparent !important;
  text-transform: capitalize;
}
.answer-button {
  text-decoration: underline;
  background-color: transparent !important;
  text-transform: capitalize;
  color: #455a64 !important;
}
.ql-toolbar {
  background-color: #f0f0f0;
}
@media (min-width: 960px) {
  .message-body {
    width: 90%;
  }
  .hide-button {
    top: 7px;
    right: 5px;
    float: right;
  }
}
</style>
